import { useState } from "react";
import { format, isSameDay } from "date-fns";

import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { useDeleteStandardException } from "features/appointments/hooks/useDeleteStandardException";

import { ChangeStatusButton } from "./ChangeStatusButton";
import styles from "./StandardExceptionItem.module.css";

export const StandardExceptionItem = ({ item, onEditException }) => {
  const exception = item.meeting.exception;

  const startDate = new Date(exception.startDate);
  const endDate = new Date(exception.endDate);

  const isOneDayException = isSameDay(startDate, endDate);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { mutate: deleteException, isPending } = useDeleteStandardException({
    onSuccess: () => setShowDeleteModal(false),
  });

  return (
    <div
      className={styles.standardExceptionItem}
      style={{
        minHeight: `${
          (item.rowSpan || 1) * 45 + Math.max(0, (item.rowSpan || 1) - 1) * 12
        }px`,
      }}
    >
      <div className={styles.exceptionHeader}>
        <h4>Availability Exception</h4>
        <ChangeStatusButton
          exceptionId={exception.id}
          deleteException={() => setShowDeleteModal(true)}
          editException={onEditException}
        />
      </div>
      <p>{exception.reason}</p>
      <p>
        {isOneDayException
          ? format(startDate, "dd MMM")
          : `${format(startDate, "dd MMM")} - ${format(endDate, "dd MMM")}`}
      </p>

      <Dialog
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="Delete Availability Exception"
        width={480}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <p style={{ fontSize: "16px", color: "#26252c", margin: 0 }}>
            Are you sure you want to delete this availability exception?
          </p>
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}
          >
            <Button
              variant="outline"
              size="large"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              size="large"
              onClick={() => deleteException(exception.exceptionId)}
              disabled={isPending}
            >
              {isPending ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
